import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container } from "@mui/material";
import { usersSliceSelector } from "../../redux/features/usersSlice";
import { organizationsSliceSelector } from "../../redux/features/organizationsSlice";

const AdminEvents = () => {
  const usersState = useSelector((state) => usersSliceSelector(state));
  const organizationsState = useSelector((state) =>
    organizationsSliceSelector(state),
  );
  const { authState } = usersState;
  const { currentOrganization } = organizationsState;

  if (authState !== "in" || !currentOrganization) {
    return;
  }

  return (
    <Container sx={{ px: { xs: 0, md: 3 } }}>
      <Outlet />
    </Container>
  );
};

export default AdminEvents;
